import { render } from "./NoInfoPlaceholder.vue?vue&type=template&id=9e3ffc96"
import script from "./NoInfoPlaceholder.vue?vue&type=script&lang=js"
export * from "./NoInfoPlaceholder.vue?vue&type=script&lang=js"

import "./NoInfoPlaceholder.vue?vue&type=style&index=0&id=9e3ffc96&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__